module.exports = __webpack_public_path__ + "media/images/guide-thumb-9t-84f81b481e5095b301803374ced73d6a.png";